import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {XWaySymbol} from "../../reels/symbols/XWaySymbol";


export class XWaysSizeRevealPresentation implements SimplePresentation {
    name: string = "XWaysRevealPresentation";
    private _revealTl: gsap.core.Timeline;

    shouldRun(): boolean {
        return XwaysHoarder2.model.xwayPos.length > 0 && !XwaysHoarder2.model.checkRespinScenario;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._revealTl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish();
            }
        });


        // reveal size

        XwaysHoarder2.model.xwayPos.forEach((pos: PIXI.Point) => {//pos[0]=reel id,pos[1]=row id;
            const xwReelID: number = pos.x;
            const xwRowID: number = pos.y;
            if (XwaysHoarder2.reelView.reels[xwReelID].model.getVisibleSymbolAt(xwRowID).name === "XW") {
                const xwSym: XWaySymbol = <XWaySymbol>XwaysHoarder2.reelView.reels[xwReelID].model.getVisibleSymbolAt(xwRowID).positionable;
                this._revealTl.add(xwSym.revealXwaysSize(XwaysHoarder2.model.featureMap && XwaysHoarder2.model.featureMap.XW ? XwaysHoarder2.model.featureMap.XW[xwReelID][xwRowID] : -1), 0);
            }
        });


        controller.setSkipCallback(() => this.onRevealSkip());



    }

    private onRevealSkip(): void {
        this._revealTl.totalProgress(1);
    }

}